import { ParseKeys } from 'i18next'
import { usePermissions } from '~/entities/common/viewer'
import { canShowObject } from '~/shared/lib/utils'

type Header = { label: ParseKeys; to: string; parent?: string }

export const useHeader = (): Header[] => {
  const {
    canCarsView,
    canDriversView,
    canWorkRulesView,
    canBalanceSectionView,
    canTaxiparkSectionView,
    canViewCarRentals,
    canViewCarLicensees,
    canViewDashboards,
  } = usePermissions()

  return [
    ...canShowObject<Header>(canCarsView, {
      label: 'cars',
      to: '/cars',
    }),
    ...canShowObject<Header>(canDriversView, {
      label: 'drivers',
      to: '/drivers',
    }),
    ...canShowObject<Header>(canBalanceSectionView, {
      label: 'balances',
      to: '/balance/balance-histories',
      parent: '/balance',
    }),
    ...canShowObject<Header>(canWorkRulesView, {
      label: 'working conditions',
      to: '/work-rules',
    }),
    ...canShowObject<Header>(canTaxiparkSectionView, {
      label: 'taxipark',
      to: '/taxipark/information',
      parent: '/taxipark',
    }),
    ...canShowObject<Header>(canViewCarRentals || canViewCarLicensees, {
      label: 'organizations',
      to: canViewCarRentals
        ? '/organizations/car-rentals'
        : '/organizations/car-licensees',
      parent: '/organizations',
    }),
    ...canShowObject<Header>(canViewDashboards, {
      label: 'dashboards',
      to: '/dashboards',
      parent: '/dashboards',
    }),
  ]
}
